export const REFERER_OPTIONS = [
  { label: 'Search engine', value: 'search-engine' },
  { label: 'Blog', value: 'blog' },
  { label: 'Podcast', value: 'podcast' },
  { label: 'AI assistant', value: 'ai-assistant' },
  { label: 'Conference', value: 'conference' },
  { label: 'GitHub', value: 'github' },
  { label: 'Reddit', value: 'reddit' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Hacker News', value: 'hacker-news' },
  { label: 'Referral', value: 'referral' },
  { label: 'Social media', value: 'social-media' },
  { label: 'Other', value: 'other' },
] as const;

export const REFERER_OPTION_VALUES = [
  'search-engine',
  'blog',
  'podcast',
  'ai-assistant',
  'conference',
  'github',
  'reddit',
  'youtube',
  'hacker-news',
  'referral',
  'social-media',
  'other',
] as const satisfies ReadonlyArray<(typeof REFERER_OPTIONS)[number]['value']>;
